<template>
  <Menu
    ref="dropdown"
    :boundary="boundary"
    :class="showPopover ? 'cursor-pointer full-height' : ''"
    :disabled="!showPopover"
    :overflow-padding="16"
    :placement="placement"
    auto-boundary-max-size
    instant-move
  >
    <span :class="showPopover ? 'flex no-wrap items-center full-height' : ''">
      {{ value?.slice(0, maxLength) }}
      <span v-if="showPopover">...</span>
    </span>

    <template #popper>
      <span>{{ value }}</span>
    </template>
  </Menu>
</template>

<script setup>
import { Menu } from "floating-vue";
import "floating-vue/dist/style.css";

const props = defineProps({
  value: {
    type: String,
    default: "",
  },

  maxLength: {
    type: Number,
    default: 20,
  },

  placement: {
    type: String,
    default: "right",
  },

  depth: {
    type: Number,
    default: 2,
  },
});

const dropdown = ref(null);

const boundary = computed(() => {
  let parent = dropdown.value?.$el;

  for (let i = 0; i < props.depth; i++) {
    parent = parent?.offsetParent;
  }

  return parent;
});

const showPopover = computed(() => props.value?.length > props.maxLength);
</script>

<style lang="scss" scoped>
:global(.v-popper--theme-dropdown .v-popper__inner) {
  background: white;
  border: none;
  border-radius: 4px;
  box-shadow: $elevation-3;
  color: $neutral;
  font-size: 0.75rem;
  padding: 0.75rem;
}

:global(.v-popper--theme-dropdown .v-popper__arrow-outer) {
  border: none;
  box-shadow: $elevation-3;
}
</style>
